<template>
  <v-layout
    row
    wrap
    class="pa-4"
    justify-center
  >
    <v-flex style="max-width: 750px">
      <v-text-field
        :rules="[value => !!value || 'Required']"
        :value="general.type_name"
        label="Visitor Type Name"
        @input="_updateData('type_name', $event)"
      />
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      general: {}
    };
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        this.general = Object.assign({}, val);
      },
      immediate: true
    }
  },
  deactivated() {
    const validation = true;
    this.$emit('update', [this.general, validation]);
  },
  methods: {
    _updateData(key, val) {
      this.general[key] = val !== undefined ? val : null;
    }
  }
};
</script>

